const defaultTitle = "Loading";

const state = {
  active: false,
  title: defaultTitle,
  subTitle: "",
  shouldRefresh: false
};

const getters = {};

const actions = {
  loaderInitiate({ commit }, { title, subtitle, shouldRefresh }) {
    commit("initiate_loader", { title, subtitle, shouldRefresh });
  },
  loaderCancel({ commit }) {
    commit("cancel_loader");
  }
};

const mutations = {
  initiate_loader(state, { title, subtitle, shouldRefresh }) {
    state.active = true;
    state.title = title;
    state.subTitle = subtitle;
    state.shouldRefresh = shouldRefresh ? shouldRefresh : false;
  },
  cancel_loader(state) {
    state.active = false;
    state.title = defaultTitle;
    state.subTitle = "";
    state.shouldRefresh = false;
  }
};

export const loader = {
  state,
  getters,
  actions,
  mutations
};
